import { createModule } from 'saga-slice';
import {
  fetchFinancialFramesSagaFactory,
  updateFinancialFrameSagaFactory,
  fetchGlobalForecastSagaFactory,
  submitGlobalForecastSagaFactory,
} from './sagas';
import {
  initialState,
  FinancialFramesState,
  FinancialFrame,
  FinancialFrameUpdate,
  GlobalForecast,
  GlobalForecastSubPortfolio,
} from './stateType';

const FinancialFramesSlice = createModule({
  name: 'financialFrames',
  initialState,
  reducers: {
    fetchFinancialFrames: (state: FinancialFramesState) => {
      state.loading = true;
    },
    fetchFinancialFramesSuccess: (
      state: FinancialFramesState,
      payload: FinancialFrame[],
    ) => {
      state.loading = false;
      state.loaded = true;
      state.financialFrames = payload;
    },
    fetchFinancialFramesError: (
      state: FinancialFramesState,
      payload: Error,
    ) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload;
    },
    updateFinancialFrame: (state: FinancialFramesState) => {
      state.updateLoading = true;
    },
    updateFinancialFrameSuccess: (
      state: FinancialFramesState,
      payload: { id: number; body: FinancialFrameUpdate },
    ) => {
      state.updateLoading = false;
      state.financialFrames = state.financialFrames.map((frame) =>
        frame.id === payload.id
          ? {
              ...frame,
              ...payload.body,
              updatedAt: new Date().toISOString(),
            }
          : frame,
      );
    },
    updateFinancialFrameError: (
      state: FinancialFramesState,
      payload: Error,
    ) => {
      state.updateLoading = false;
      state.error = payload;
    },
    fetchGlobalForecast: (state: FinancialFramesState) => {
      state.globalForecastLoading = true;
    },
    fetchGlobalForecastSuccess: (
      state: FinancialFramesState,
      payload: GlobalForecast,
    ) => {
      state.globalForecastLoading = false;
      state.globalForecast = payload;
    },
    fetchGlobalForecastError: (state: FinancialFramesState, payload: Error) => {
      state.globalForecastLoading = false;
      state.globalForecast = null;
      state.error = payload;
    },
    submitGlobalForecast: (state: FinancialFramesState) => {
      state.globalForecastSubmitLoading = true;
    },
    submitGlobalForecastSuccess: (
      state: FinancialFramesState,
      payload: GlobalForecastSubPortfolio,
    ) => {
      state.globalForecastSubmitLoading = false;
      if (state.globalForecast) {
        state.globalForecast.subPortfolios =
          state.globalForecast.subPortfolios.map((entry) =>
            entry.subPortfolio === payload.subPortfolio ? payload : entry,
          );
      }
    },
    submitGlobalForecastError: (
      state: FinancialFramesState,
      payload: Error,
    ) => {
      state.globalForecastSubmitLoading = false;
      state.error = payload;
    },
  },
  sagas: (actions) => ({
    [actions.fetchFinancialFrames]: fetchFinancialFramesSagaFactory(actions),
    [actions.updateFinancialFrame]: updateFinancialFrameSagaFactory(actions),
    [actions.fetchGlobalForecast]: fetchGlobalForecastSagaFactory(actions),
    [actions.submitGlobalForecast]: submitGlobalForecastSagaFactory(actions),
  }),
});

export default FinancialFramesSlice;
export const financialFramesActions = FinancialFramesSlice.actions;
